// @ts-ignore
import { fetchDedupe } from "fetch-dedupe";
import type { IntlProviderOptions } from '../services/I18n';

type JsonReturnType = string | number | object | any[] | boolean | null;
export type DecodedJsonData = JsonReturnType

const defaultOptions = { basePath: `./static/locale` };

export function getIntlConfigByLocale(
  locale: Intl.UnicodeBCP47LocaleIdentifier | 'global',
  options?: Pick<IntlProviderOptions, 'apiService'>
) {
  const settings = { ...defaultOptions, ...options };
  const source:string = [settings.basePath, `${locale}.json`].join('/').replace('//', '/');

  console.log('source', source);

  const transform = (data:DecodedJsonData) => ({
    translations: data,
    locale,
    source,
  });

  // @ts-ignore
  return fetchDedupe(source)
    .then((res) => res.data)
    .then((data:DecodedJsonData) => transform(data));
}

export default getIntlConfigByLocale;
